import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Reset = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.35355 0.853553C7.54882 0.658291 7.54882 0.341709 7.35355 0.146447C7.15829 -0.0488155 6.84171 -0.0488155 6.64645 0.146447L4.14645 2.64645C3.95118 2.84171 3.95118 3.15829 4.14645 3.35355L6.64645 5.85355C6.84171 6.04882 7.15829 6.04882 7.35355 5.85355C7.54882 5.65829 7.54882 5.34171 7.35355 5.14645L5.70711 3.5H7.45C11.061 3.5 13 6.23385 13 8.6392C13 11.026 10.7554 13.5 8 13.5C5.1736 13.5 3 11.5092 3 9.1892C3 8.91306 2.77614 8.6892 2.5 8.6892C2.22386 8.6892 2 8.91306 2 9.1892C2 12.1831 4.75127 14.5 8 14.5C11.3197 14.5 14 11.5662 14 8.6392C14 5.73069 11.6612 2.5 7.45 2.5H5.70711L7.35355 0.853553Z"
        fill={color}
      />
    </svg>
  )
})

export default Reset
